import { FunctionComponent, Suspense, lazy } from 'react'
import { ScrollToTop } from '../content/utilities/scrollToTop'
import { Header } from '../content/sections/header/Header'
import { Footer } from '../content/sections/footer/Footer'
import { Outlet } from 'react-router-dom'
import { NotificationListComponent } from '@vista-digital/occ-ui/src/lib/components/notification-list/notification-list'

export const Layout: FunctionComponent = () => {
    return (
        <>
            <Header />
            <ScrollToTop />

            <div className="page-wrapper">
                <Outlet />
            </div>

            <NotificationListComponent />
            <Footer />
        </>
    )
}
